// Components
import WorkshopDetails from './steps/WorkshopDetails';
import WorkshopNotes from './steps/WorkshopNotes';
import WorkshopSchedule from './steps/WorkshopSchedule';
import WorkshopSummary from './steps/WorkshopSummary';

// Hooks
import { STEPS, useWorkshopStepContext } from './WorkshopStepContext';

function WorkshopStepFactory({ isSubmitting }: { isSubmitting?: boolean }) {
  const { currentStep } = useWorkshopStepContext();

  switch (currentStep) {
    case STEPS.DETAILS:
      return <WorkshopDetails />;
    case STEPS.SCHEDULE:
      return <WorkshopSchedule />;
    case STEPS.NOTES:
      return <WorkshopNotes />;
    case STEPS.SUMMARY:
      return <WorkshopSummary isSubmitting={isSubmitting} />;
    default:
      throw new Error('Invalid step number');
  }
}

export default WorkshopStepFactory;
